import {StyleSheet} from 'react-native';

import {indent} from '/constant/layout.constant';
import {cloudLight} from '/theme/color/on.color';

export const styles = StyleSheet.create({
  base: {},
  header: {
    paddingVertical: indent,
    borderBottomWidth: 1,
    borderBottomColor: cloudLight,
  },
  listItem: {
    borderBottomWidth: 1,
    borderBottomColor: cloudLight,
  },
  loadingBoxEligibleThrough: {
    height: 20,
    width: 100,
  },
  loadingBoxDate: {
    height: 20,
    width: 200,
  },
  bonusProgressBar: {
    paddingVertical: indent * 0.8,
    borderBottomColor: cloudLight,
    borderBottomWidth: 1,
  },
  bonusProgressBarSection: {
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  boxTitle: {
    margin: indent * 0.4,
  },
  loadingBoxProgressBar: {
    height: 40,
    width: 300,
    marginBottom: indent * 0.4,
  },
  loadingBoxProgressBarMoneyEarned: {
    height: 20,
    width: 50,
    alignSelf: 'flex-end',
  },
});
